import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'iq-central-front-end-setting-privileges',
  templateUrl: './setting-privileges.component.html',
  styleUrls: ['./setting-privileges.component.scss']
})
export class SettingPrivilegesComponent implements OnInit {

  Privileges;
  constructor() { }

  ngOnInit(): void {
    this.Privileges = [1,2,3,4]
  }

}
